import { briefingsDefaultBlockTypes, briefingsSubBlockTypes } from './briefings-block-types.model';
import { BlockTypeGroupModel } from '../../../Common/PageBuilder/models/block-type-group.model';

/**
 * Built lazily (a function, not a top-level const) so it reads the block-type arrays at call
 * time rather than at module-evaluation time. Some block-type field components import
 * BriefingsService, which imports this module, forming an import cycle; a const array could
 * capture `undefined` block-types if this module happened to evaluate before
 * `briefings-block-types` finished. Reading them via a function defers to runtime, when both
 * modules are fully initialized.
 */
export function getBriefingsBlockTypeGroups(): BlockTypeGroupModel[] {
    return [
        {
            blockTypes: briefingsDefaultBlockTypes
        },
        {
            blockTypes: briefingsSubBlockTypes
        }
        // For now we are hiding the mention list types from the block adder so the user must add them via other means
        // {
        //     header: 'Briefings.blockGroup.MentionsList',
        //     blockTypes: briefingsMentionListBlockTypes
        // }
    ];
}
